import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TableBody,
  TableCell,
  TableRow
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import ResponsiveTable from "@saleor/components/ResponsiveTable/ResponsiveTable";
import React from "react";
import { FormattedMessage } from "react-intl";

export interface CouponViewMallsProps {
  couponMallsList: any[];
  allMallsList: any[];
  loading: boolean;
  onClose: () => void;
  open: boolean;
}

const useStyles = makeStyles(
  () => ({
    container: {
      maxHeight: "60%"
    },
    loadingIcon: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center"
    },
    modal: {
      "& .MuiDialog-paperScrollPaper": {
        maxHeight: "60%"
      },
      "& .MuiPaper-rounded": {
        borderRadius: "15px"
      }
    },
    titleBar: {
      display: "flex",
      fontWeight: "bolder",
      justifyContent: "space-between",
      width: "100%"
    },
    wideCell: {
      width: "100%"
    }
  }),
  { name: "CouponViewMalls" }
);

const CouponViewMallsDialog: React.FC<CouponViewMallsProps> = ({
  onClose,
  open,
  couponMallsList,
  loading,
  allMallsList
}) => {
  const classes = useStyles("");
  const mallsList =
    couponMallsList?.length > 0 ? couponMallsList : allMallsList;

  return (
    <Dialog
      onClose={onClose}
      open={open}
      fullWidth
      maxWidth="sm"
      className={classes.modal}
    >
      <DialogTitle>
        <div className={classes.titleBar}>
          <FormattedMessage
            defaultMessage="Participating Malls"
            description="participating mall list"
          />
          <Button onClick={onClose}>
            <CloseIcon
              style={{
                margin: "0"
              }}
            />
          </Button>
        </div>
      </DialogTitle>
      <DialogContent className={classes.container}>
        <ResponsiveTable>
          <TableBody>
            {loading ? (
              <div className={classes.loadingIcon}>
                <CircularProgress size={32} />
              </div>
            ) : (
              mallsList &&
              mallsList.map((mall, index) => (
                <TableRow key={mall} id={`mallRow${index}`}>
                  <TableCell className={classes.wideCell}>{mall}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </ResponsiveTable>
      </DialogContent>
    </Dialog>
  );
};
CouponViewMallsDialog.displayName = "CouponViewMallsDialog";
export default CouponViewMallsDialog;
